import { render } from "./Orders.vue?vue&type=template&id=43e1c18b&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=43e1c18b&lang=scss"
import "./Orders.vue?vue&type=style&index=1&id=43e1c18b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e1c18b"]])

export default __exports__